<template>
	<v-overlay
		scrim="red"
		v-model="showOverlay"
	>
		<v-card
			class="ma-auto text-center transparent"
			flat
		>
			<v-progress-circular
				color="primary"
				indeterminate
				size="180"
				width="6"
			>loading</v-progress-circular>
		</v-card>
	</v-overlay>
</template>
<script lang="ts">

	export default {
		props: {
		},

		data: (): any => {
			return {
				showOverlay: true,
			}
		},

		computed: {
		},
	}
</script>